export function dashboardExperimentEnabled(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
): boolean {
  return hostname === 'staging.skyspace.me'
    || hostname === 'skyspace.me'
    || hostname === 'www.skyspace.me'
    || hostname === 'localhost'
    || hostname === '127.0.0.1';
}
